(($) => {

    "use strict";

    $.enhancer("customFileUpload", function () {
        const fileList = $(this).find('.FormFileUpload__PostedFile');
        const template = fileList.find('.file').first();
        template.remove();

        $(this).on('change', function () {
            const getFiles = $(this).find('.custom-file-input').prop('files');
            const fileArr = Array.from(getFiles);

            function removeFile (index, element) {
                fileArr.splice(index, 1);
                element.remove();
            }

            $.each(fileArr, function (index, value) {
                const file = template.clone();
                file.find('.file-name').text(value.name);
                file.removeClass('d-none');

                //file.find('.btn').on('click', function () {
                //    removeFile(index, $(this).parent());
                //})

                fileList.append(file);
            })

        })
    });

})(jQuery);
